<template>
  <div>
    <Modal :value="medal" @on-visible-change="visibleChange" title="创建新数据" width="700px">
      <Form
        inline
        :label-width="100"
        label-position="right"
        ref="dict"
        :model="dict"
        :rules="ruleValidate"
      >
        <FormItem label="数据名称" prop="name">
          <Input v-model="dict.name" class="ivu-width"></Input>
        </FormItem>
        <FormItem label="上级" prop="parent">
          <Input v-model="dict.parent" class="ivu-width" readonly></Input>
        </FormItem>
        <FormItem label="所属类型" prop="type">
          <Input v-model="dict.type" class="ivu-width"></Input>
        </FormItem>
        <FormItem label="简称" prop="code">
          <Input v-model="dict.code" class="ivu-width"></Input>
        </FormItem>
        <FormItem label="序列号" prop="sort">
          <Input v-model="dict.sort" class="ivu-width"></Input>
        </FormItem>
        <FormItem label="备注" prop="describe">
          <Input v-model="dict.describe" class="ivu-width"></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="ok('dict')">确认</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import { FieldType, Filter, CompareType } from "../../../store/entities/filter";
import PageRequest from "../../../store/entities/page-request";
import ajax from "../../../lib/ajax";
import axios from "axios";
import { isNull } from 'util';
var Url = "http://qy.chinapsp.cn:8883";
export default {
  props: ["medal", "ed", "now_type", "parentId"],
  data() {
    return {
      dict: {
        name: "",
        parent: "",
        type: "",
        code: "",
        sort: "",
        describe: "",
        id: "",
      },
      ruleValidate: {
        name: [{ required: true, message: "请完善资料", trigger: "blur" }],
        //parent: [{ required: false, message: "请此完善资料", trigger: "blur" }],
        type: [{ required: true, message: "请完善资料", trigger: "blur" }],
        code: [{ required: true, message: "请完善资料", trigger: "blur" }],
        sort: [{ required: false, message: "请完善资料", trigger: "blur" }],
        describe: [{ required: false, message: "请完善资料", trigger: "blur" }]
      }
    };
  },
  methods: {
    ok(name) {
      let para = this.$refs[name].model;
      this.$refs[name].validate(value => {
        if (value) {
          ajax
            .post("/api/services/app/AbpDataDict/CreateOrUpdate", {
              abpDataDict: {
                id: para.id,
                itemName: para.name,
                itemParent: para.parent,
                itemType: para.type,
                itemSort: para.sort,
                itemCode: para.code,
                describe: para.describe
              }
            })
            .then(res => {
              if (res.data.success) {
                this.$Message.success("新增成功！");
              } else {
                this.$Message.success("操作出错！");
                return;
              }
              this.$emit("medal_ch", false); //改变父组件的值 是的子组件改变
              this.dict = {
                name: "",
                parent: "",
                type: "",
                code: "",
                sort: "",
                describe: "",
                id: "",
              };
            });
        }
      });
    },
    visibleChange(value) {
      if (value) {
        if (this.ed < 0) {
          this.dict = {
            name: "",
            parent: "",
            type: "",
            code: "",
            sort: "",
            id: "",
            describe: ""
          }
          if (this.ed == -2) {
            this.dict.type = this.now_type
            this.dict.parent = this.parentId.toString()
          }
        } else {
          ajax
            .get("/api/services/app/AbpDataDict/GetForEdit?id=" + this.ed)
            .then(res => {
              let data = res.data.result.abpDataDict;
              this.dict = {
                name: data.itemName,
                parent: data.itemParent,
                type: data.itemType,
                code: data.itemCode,
                sort: data.itemSort,
                describe: data.describe,
                id: data.id,
              }
              if (!isNull(data.itemSort)) {
                this.dict.sort = data.itemSort.toString()
              }
            })
        }
      }
      if (!value) {
        this.$emit("medal_ch", value);
      }
    }
  }
};
</script>